module.exports = __webpack_public_path__ + "static/media/path2.ba1c7384.jpg";